module.exports = new __parcel__URL__("battlepass_mini_rock.51d50952.png").toString();